import { Stack, SxProps, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { Status } from './Status';
import { shortDateFormat } from 'Config';

interface IDataItem {
  title: string;
  paymentAmount?: number | boolean;
  requestNumber?: number | string;
  lastUpdateDate?: Date;
  status?: number;
}
export const DataItem = ({
  title,
  paymentAmount,
  requestNumber,
  lastUpdateDate,
  status,
}: IDataItem) => {
  const isDesktop = useIsDesktop();

  const moneyStyle: SxProps =
    typeof paymentAmount === 'number'
      ? paymentAmount > 0
        ? { color: 'success.main' }
        : { color: 'error.main' }
      : {};

  return (
    <Stack
      direction='column'
      justifyContent='center'
      width={isDesktop ? 'fit-content' : '45%'}
      minWidth='90px'
      gap={isDesktop ? '11px' : '4px'}
      height='fit-content'
    >
      <Typography variant={'body6'} whiteSpace='nowrap'>
        {title}
      </Typography>
      {typeof paymentAmount === 'boolean' ? (
        <Typography variant={'body2'}>
          {
            Dictionary[DICTIONARY.PaymentsDeductions].paymentDeductionCard
              .noDecision
          }
        </Typography>
      ) : (
        typeof paymentAmount === 'number' && (
          <Typography
            variant={'body2'}
            sx={{
              ...moneyStyle,
              direction: 'rtl',
              textAlign: 'left',
            }}
          >
            <span style={{ fontSize: '12px' }}>₪</span>
            {paymentAmount}
          </Typography>
        )
      )}
      {requestNumber && (
        <Typography variant={'body2'}>{requestNumber}</Typography>
      )}
      {lastUpdateDate && (
        <Typography variant={'body2'}>
          {format(new Date(lastUpdateDate), shortDateFormat)}
        </Typography>
      )}
      {status && <Status statusCode={status} />}
    </Stack>
  );
};
